import {
  refresh as refreshUsers
} from '../redux/users'
import _requestRemoveUserFromGroup from 'store/sagas/requestRemoveUserFromGroup'

type Payload = {
  boardId: number
  userId: number
  userGroupId: number
}

export default (payload: Payload) => async dispatch => {
  const { boardId, userId, userGroupId } = payload

  await dispatch(_requestRemoveUserFromGroup({
    userId,
    userGroupId
  }))

  dispatch(refreshUsers({
    boardId
  }))
}
